module.exports = __webpack_public_path__ + "static/media/medzing-bg.7445787f.jpg";